import * as React from "react";
import { forwardRef } from "react";
const SvgRoundedRectangle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 28 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { y: 0.703125, width: 27.888, height: 11.5939, rx: 5.79695, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgRoundedRectangle);
export { ForwardRef as ReactComponent };
